export default function loadHotjarScript() {
    (function(h,o,t,j,a,r){ // @ts-ignore
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; // @ts-ignore
        h._hjSettings={hjid:1339416,hjsv:6}; // @ts-ignore
        a=o.getElementsByTagName('head')[0]; // @ts-ignore
        r=o.createElement('script');r.async=1; // @ts-ignore
        r.id='hotjar-script'; // @ts-ignore
        r.setAttribute('data-testid','hotjar-script'); // @ts-ignore
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; // @ts-ignore
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
};